module.exports = __webpack_public_path__ + "media/images/img04-9f33a8fe845a0ace4c7a5eddc22a10ca.png";